import { SnackbarState, TitleTree } from "../domain/domain";

export type UiState = {
    snackbarState: SnackbarState,
    printingOptionsDialogOpen: boolean,
    printingOptionsDialogSubTree: TitleTree | undefined
}

const initialState: UiState = {
    snackbarState: {
        open: false,
        message: "",
        severity: "success"
    },
    printingOptionsDialogOpen: false,
    printingOptionsDialogSubTree: undefined
}

export enum UiActionType {
    SNACKBAR_STATE_CHANGED = "SNACKBAR_STATE_CHANGED",
    PRINTING_OPTIONS_DIALOG_OPEN = "PRINTING_OPTIONS_DIALOG_OPEN"
}

export interface SnackbarStateChanged {
    type: UiActionType.SNACKBAR_STATE_CHANGED,
    newState: SnackbarState
}

export interface PrintingOptionsDialogOpen {
    type: UiActionType.PRINTING_OPTIONS_DIALOG_OPEN,
    open: boolean,
    subTree: TitleTree | undefined
}

export type UiActions = SnackbarStateChanged | PrintingOptionsDialogOpen

export function uiReducer(
    state = initialState,
    action: UiActions
    ): UiState {
        switch (action.type) {
            case UiActionType.SNACKBAR_STATE_CHANGED:
                return {
                    ...state,
                    snackbarState: action.newState
                }
            case UiActionType.PRINTING_OPTIONS_DIALOG_OPEN:
                return {
                    ...state,
                    printingOptionsDialogOpen: action.open,
                    printingOptionsDialogSubTree: action.open ? action.subTree : undefined
                }
            default:
                return state;
        }
    }